import { Layer } from '../types';
import type { ProjectType } from '../../models/types';

/**
 * Determines if a dependency is in base layer
 * A dependency can have multiple layers, if zero exists it's in the base layer
 * @param layers List of layers for a dependency
 */
export const isInBaseLayer = (layers: Layer[]): boolean =>
  layers.some((layer: Layer) => layer?.layerIndex === 0);

/**
 * Is a container project - checks project type
 * @param projectType project.type attribute
 */
export const isContainerProject = (projectType?: ProjectType) => projectType === 'container';
